export const CONSTANTS=
{
    pageSize:5,
    maxPagesNumber:7,
    otpCorrelationHeader:"X-Otp-Correlation-Id",


    urls:
    {
        lookups:"http://localhost:90/api/lookup",
        ordering:"",
        authentication:"/adahiapi/api/users/",
        activateProfile:"/adahiapi/api/users/activate/"
    }
}